export default __webpack_public_path__ + "static/media/img-proj-urban-transit.eb827d61.png";